<cm-card>
  <cm-text appearance="emphasis" slot="header"
    >{{ baseUrl }}{{ orgUuid }}/clusters/{{
      clusterUuid
    }}/internalClient</cm-text
  >
  <pre><code>{{ data }}</code></pre>
</cm-card>
